import isBrowser from '@src/quince-site-common/src/utils/isBrowser'

import { IExperimentLoggingData } from '../experiments.types'

const LOCALSTORAGE_KEY = 'statsigExperimentBuckets'

export class StatsigExperimentManager {
  exposedBuckets: Record<string, string>

  constructor() {
    this.exposedBuckets = {}
  }

  initialize() {
    const existingBuckets = this.getExposedBucketsFromLocalStorage()

    existingBuckets.forEach(({ experimentName, bucketName } = { experimentName: '', bucketName: '' }) => {
      if (!experimentName || !bucketName) return
      this.exposedBuckets[experimentName] = bucketName
    })
  }

  setExposedBuckets(experimentName: string, groupName: string) {
    this.exposedBuckets[experimentName] = groupName

    this.setExposedBucketsInLocalStorage()
  }

  getExposedBuckets() {
    const experimentBuckets: IExperimentLoggingData[] = []
    Object.entries(this.exposedBuckets).forEach(([experimentName, bucketName]) => {
      experimentBuckets.push({
        experimentName,
        bucketName,
      })
    })
    return Object.freeze(experimentBuckets)
  }

  removeExposedBuckets(experimentName: string) {
    if (this.exposedBuckets[experimentName])
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this.exposedBuckets[experimentName]
  }

  private setExposedBucketsInLocalStorage() {
    try {
      if (!isBrowser()) return void 0

      const experimentBuckets = this.getExposedBuckets()

      localStorage.setItem(LOCALSTORAGE_KEY, JSON.stringify(experimentBuckets))
    } catch (error) {
      console.error(`Failed to set Statsig Experiment buckets in Local storage: `, error)
    }
  }

  private getExposedBucketsFromLocalStorage() {
    try {
      if (!isBrowser()) return []

      const existingBuckets = JSON.parse(localStorage.getItem(LOCALSTORAGE_KEY) ?? '[]') as IExperimentLoggingData[]
      if (!Array.isArray(existingBuckets)) {
        return []
      }
      return existingBuckets
    } catch (error) {
      console.error(`Failed to get Statsig Experiment buckets from Local storage: `, error)
      return []
    }
  }
}

export const statsigExperimentManager = new StatsigExperimentManager()
